export const SITE = {
  name: "LearnWithTAC",
  domain: "learnwithtac.com",
  tagline: "Master Real-World IT Security with 1-on-1 Industry Engineers",
  whatsappNumber: "917696118858",
  whatsappDisplay: "+91 76961 18858",
  whatsappMessage: "Hi LearnWithTAC, I am interested in 1-on-1 Live Engineering Training. Please share details.",
  lmsLoginUrl: "https://lms.learnwithtac.com/login",
  lmsSignupUrl: "https://lms.learnwithtac.com/signup",
  email: "info@learnwithtac.com",
  youtube: "https://www.youtube.com/channel/UCi3aqUgVA_N0IIomZFynOzQ",
  instagram: "https://www.instagram.com/learn_with_tac/",
  facebook: "https://www.facebook.com/profile.php?id=61595057945374",
};

export const ADDRESSES = {
  india: "2nd Floor, Homeland Sector 70, 70th Avenue, Sector 70, Sahibzada Ajit Singh Nagar, Mohali, Punjab 160071",
  usa: "USA office address updating soon — write to info@learnwithtac.com",
};

export const whatsappLink = (msg = SITE.whatsappMessage) =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(msg)}`;

export const IMAGES = {
  heroVideo: "/videos/hero-lab.mp4",
  hero: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxjeWJlciUyMHNlY3VyaXR5JTIwc2VydmVyJTIwbmV0d29yayUyMGRhdGElMjBjZW50ZXJ8ZW58MHx8fHwxNzkwMzU5MDIwfDA&ixlib=rb-4.1.0&q=85",
  datacenter: "https://images.unsplash.com/photo-1506399558188-acca6f8cbf41?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxjeWJlciUyMHNlY3VyaXR5JTIwc2VydmVyJTIwbmV0d29yayUyMGRhdGElMjBjZW50ZXJ8ZW58MHx8fHwxNzkwMzU5MDIwfDA&ixlib=rb-4.1.0&q=85",
  cloud: "https://images.unsplash.com/photo-1573164713988-8665fc963095?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwzfHxjbG91ZCUyMGNvbXB1dGluZyUyMGVuZ2luZWVyJTIwdGVjaCUyMHN0dWRlbnR8ZW58MHx8fHwxNzkwMzU5MDIwfDA&ixlib=rb-4.1.0&q=85",
  cyber: "https://images.unsplash.com/photo-1549692520-acc6669e2f0c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHxjbG91ZCUyMGNvbXB1dGluZyUyMGVuZ2luZWVyJTIwdGVjaCUyMHN0dWRlbnR8ZW58MHx8fHwxNzkwMzU5MDIwfDA&ixlib=rb-4.1.0&q=85",
  ai: "https://images.unsplash.com/photo-1674027444485-cec3da58eef4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxhcnRpZmljaWFsJTIwaW50ZWxsaWdlbmNlJTIwbmV0d29ya3xlbnwwfHx8fDE3OTA0OTI3MzJ8MA&ixlib=rb-4.1.0&q=85",
};

export const TRAINERS = [
  {
    id: "aviraj",
    name: "Aviraj Sharma",
    role: "Ex-Cisco TAC Engineer",
    company: "Cisco Systems (Ex-TAC), Ex-Juniper Networks",
    experience: "14+ Years",
    detail: "Enterprise routing, SD-WAN & data-center troubleshooting at Cisco TAC",
    specialization: "CCNA, CCNP (ENCOR/ENARSI), Cisco SD-WAN, F5 LTM, Check Point, ASA/FTD",
    image: "https://images.unsplash.com/photo-1771244670407-42e9585ab333?auto=format&fit=crop&w=800&q=80",
    track: "Network Security",
  },
  {
    id: "piyush",
    name: "Piyush Mahajan",
    role: "Cloud Security Expert",
    company: "Microsoft (Azure), Ex-VMware",
    experience: "11+ Years",
    detail: "Azure architecture, virtualization & cloud security for enterprises",
    specialization: "CCNA, MCSA, VMware, Azure (AZ-900/104/500/700/400), Cloud Security",
    image: "https://images.unsplash.com/photo-1729157661483-ed21901ed892?auto=format&fit=crop&w=800&q=80",
    track: "Cloud Security",
  },
  {
    id: "sonam",
    name: "Mrs. Sonam",
    role: "Network & Cyber Security Expert",
    company: "Palo Alto Networks, Ex-Fortinet",
    experience: "12+ Years",
    detail: "NGFW deployments, AWS security & SOC operations across MNCs",
    specialization: "Palo Alto, FortiGate, CEH, AWS, Network Security & Cyber Security",
    image: "https://images.unsplash.com/photo-1770627016447-cb9d29ed0398?auto=format&fit=crop&w=800&q=80",
    track: "Network + Cyber Security",
  },
  {
    id: "anu",
    name: "Mrs. Anu",
    role: "Offensive Security Trainer",
    company: "IBM Security, Ex-HCLTech",
    experience: "10+ Years",
    detail: "VAPT engagements, firewall audits & penetration testing programs",
    specialization: "Palo Alto, CEH, CompTIA Security+, PenTest+, Linux & Kali",
    image: "https://images.unsplash.com/photo-1774850235906-f5eaafb425ac?auto=format&fit=crop&w=800&q=80",
    track: "Cyber Security",
  },
];

export const CLIENTS = [
  "CISCO", "PALO ALTO NETWORKS", "FORTINET", "AWS", "MICROSOFT AZURE",
  "JUNIPER", "GOOGLE CLOUD", "CHECK POINT", "VMWARE", "F5 NETWORKS",
];

export const YOUTUBE_VIDEOS = [
  {
    title: "Mastering Palo Alto NAT & Security Policies in 45 Minutes",
    views: "New on channel",
    duration: "46:12",
    tag: "Live TAC Lab",
    youtubeId: "dQw4w9WgXcQ",
  },
  {
    title: "How to Hack & Defend Active Directory in 2026: Hands-on Demo",
    views: "New on channel",
    duration: "1:02:18",
    tag: "Cyber Attack Lab",
    youtubeId: "3JZ_D3ELwOQ",
  },
  {
    title: "AWS IAM PrivEsc & Cloud Security Architecture Breakdown",
    views: "New on channel",
    duration: "38:45",
    tag: "Cloud Security",
    youtubeId: "L_LUpnjgPso",
  },
];

export const REVIEWS = {
  rating: 4.9,
  total: "300+ Learners Trained",
  badge: "Rated excellent by our students",
  reviews: [
    {
      name: "Vikram Shah",
      time: "CCNA + Palo Alto Student",
      text: "Best decision of my career. True 1-on-1 sessions, no batch compromises. My trainer was a working Palo Alto architect who shared real production cases.",
    },
    {
      name: "Priya Nair",
      time: "AZ-500 Student",
      text: "Affordable pricing compared to big institutes, but quality is 10x. Recordings + PDF notes + lab access. Cleared AZ-500 in my first attempt.",
    },
    {
      name: "Arjun Reddy",
      time: "F5 LTM Student",
      text: "The mock interview program is brutal and brilliant. 3 rounds of grill sessions before my actual F5 interview — cleared it with confidence.",
    },
    {
      name: "Fatima Khan",
      time: "OSCP Track Student",
      text: "OSCP prep here is hands-on from day one. Real AD labs, real exploitation, real reporting. Worth every rupee.",
    },
  ],
};

export const ROADMAPS = [
  {
    id: "network",
    track: "Network Security Roadmap",
    accent: "sky",
    stages: [
      {
        step: "Step 01",
        level: "Foundation — Associate Level",
        courses: ["CCNA 200-301"],
        keywords: "IP addressing, subnetting, VLANs, OSPF basics, routing & switching, network security fundamentals",
        detail: "Start here even with zero IT background. CCNA builds the complete networking foundation every security role demands.",
        outcome: "NOC / Network Support Engineer",
        salary: "₹3–6 LPA",
      },
      {
        step: "Step 02",
        level: "Intermediate — Professional Level",
        courses: ["CCNP ENCOR", "CCNP ENARSI", "Palo Alto PCNSE", "FortiGate NSE"],
        keywords: "Enterprise routing (BGP), NGFW policies, IPsec/SSL VPNs, GlobalProtect, HA & Panorama",
        detail: "Move from configuring devices to designing and defending enterprise networks on multi-vendor firewalls.",
        outcome: "Network Security Engineer L2/L3",
        salary: "₹8–16 LPA",
      },
      {
        step: "Step 03",
        level: "Expert — Senior & Management",
        courses: ["CCNP Security (SCOR)", "Cisco SD-WAN Mastery", "F5 BIG-IP LTM", "Check Point CCSE"],
        keywords: "Zero Trust, segmentation (ISE/TrustSec), multi-vendor architecture, design reviews, team leadership",
        detail: "Architect-level skills that lead teams — design authority, migrations and security strategy ownership.",
        outcome: "Security Architect / TAC Lead → Network Security Manager",
        salary: "₹18–35 LPA",
      },
    ],
  },
  {
    id: "cloud",
    track: "Cloud Security Roadmap",
    accent: "blue",
    stages: [
      {
        step: "Step 01",
        level: "Foundation — Associate Level",
        courses: ["Azure AZ-900", "AWS Cloud Practitioner", "Windows Server (MCSA)"],
        keywords: "Cloud concepts, IAM basics, compute & storage, shared responsibility, Active Directory basics",
        detail: "Understand how cloud actually works — services, billing and identity — before touching architecture.",
        outcome: "Cloud Support Associate / Junior Admin",
        salary: "₹3–6 LPA",
      },
      {
        step: "Step 02",
        level: "Intermediate — Professional Level",
        courses: ["Azure AZ-104", "AWS Solutions Architect (SAA)", "Azure AZ-500"],
        keywords: "Cloud administration, HA architecture, RBAC, security controls, Sentinel, monitoring",
        detail: "Run production cloud: deploy, secure and monitor workloads the way MNC cloud teams do.",
        outcome: "Cloud Engineer / Cloud Security Engineer",
        salary: "₹8–18 LPA",
      },
      {
        step: "Step 03",
        level: "Expert — Senior & Management",
        courses: ["Azure AZ-700", "Azure DevOps AZ-400", "AWS Advanced Networking", "AWS Security Specialty"],
        keywords: "Hybrid connectivity, DevSecOps pipelines, threat detection, incident response, architecture reviews",
        detail: "Own cloud security strategy — hybrid networks, automated defense and secure delivery pipelines.",
        outcome: "Cloud Security Architect / DevSecOps Lead / Cloud Manager",
        salary: "₹20–45 LPA",
      },
    ],
  },
  {
    id: "cyber",
    track: "Cyber Security Roadmap",
    accent: "orange",
    stages: [
      {
        step: "Step 01",
        level: "Foundation — Associate Level",
        courses: ["Linux & Kali", "CompTIA Security+"],
        keywords: "Linux command line, security concepts, SIEM basics, phishing triage, hardening",
        detail: "Build the attacker's toolkit and defender's vocabulary — the base every cyber role assumes.",
        outcome: "SOC Analyst L1 / Security Analyst",
        salary: "₹4–7 LPA",
      },
      {
        step: "Step 02",
        level: "Intermediate — Professional Level",
        courses: ["CEH v13", "CompTIA PenTest+"],
        keywords: "Ethical hacking, OWASP Top 10, vulnerability assessment, exploitation, professional reporting",
        detail: "Learn the full attack lifecycle legally — recon to exploitation to client-ready reports.",
        outcome: "Penetration Tester / SOC L2 / Threat Hunter",
        salary: "₹9–16 LPA",
      },
      {
        step: "Step 03",
        level: "Expert — Senior & Management",
        courses: ["OSCP", "CISSP"],
        keywords: "Advanced exploitation, AD attacks, red teaming, governance, risk management, security leadership",
        detail: "Prove elite hands-on skill (OSCP) or step into leadership and strategy (CISSP) — or both.",
        outcome: "Senior Pentester / Red Team Lead / Security Manager / CISO Track",
        salary: "₹20–40 LPA",
      },
    ],
  },
  {
    id: "ai",
    track: "AI Engineering Roadmap",
    accent: "emerald",
    stages: [
      {
        step: "Step 01",
        level: "Foundation — Associate Level",
        courses: ["AI Fundamentals & Prompt Engineering", "ML Foundations with Python"],
        keywords: "AI concepts, prompt design, Python for AI, data handling, model basics",
        detail: "Understand how AI actually works and start using it daily — no math PhD required.",
        outcome: "AI-Ready Engineer / Junior Prompt Engineer",
        salary: "₹5–9 LPA",
      },
      {
        step: "Step 02",
        level: "Intermediate — Professional Level",
        courses: ["AI for Network Engineers (AIOps)", "AI for Cloud Engineers", "AI for Cyber Security"],
        keywords: "AIOps, anomaly detection, Azure AI / AWS Bedrock, LLM-powered SOC, AI-assisted troubleshooting",
        detail: "Apply AI inside your existing domain — the fastest salary jump for network, cloud and security engineers today.",
        outcome: "AIOps Engineer / Cloud AI Engineer / AI-SOC Analyst",
        salary: "₹12–22 LPA",
      },
      {
        step: "Step 03",
        level: "Expert — Senior & Management",
        courses: ["Generative AI & LLM Engineering"],
        keywords: "RAG pipelines, AI agents, fine-tuning, LLM security, AI architecture, team leadership",
        detail: "Design and ship enterprise AI systems — and lead the teams building them.",
        outcome: "AI Solutions Architect / AI Security Lead / Head of AI",
        salary: "₹25–50 LPA",
      },
    ],
  },
];

export const GROUP_BATCHES = [
  { course: "CCNA 200-301", slug: "ccna", start: "10 Aug 2026", days: "Mon–Thu (Weekdays)", time: "8:30–10:30 PM IST", seats: 12, left: 5, trainer: "Aviraj Sharma", tag: "Filling Fast" },
  { course: "Palo Alto PCNSE & Panorama", slug: "palo-alto", start: "17 Aug 2026", days: "Sat–Sun (Weekend)", time: "5:00–8:00 PM IST", seats: 15, left: 9, trainer: "Mrs. Sonam" },
  { course: "AWS Solutions Architect SAA-C03", slug: "aws-saa", start: "24 Aug 2026", days: "Mon–Thu (Weekdays)", time: "8:00–10:00 PM IST", seats: 15, left: 11, trainer: "Mrs. Sonam" },
  { course: "Azure Administrator AZ-104", slug: "azure-104", start: "31 Aug 2026", days: "Sat–Sun (Weekend)", time: "6:00–9:00 PM IST", seats: 15, left: 12, trainer: "Piyush Mahajan" },
  { course: "CEH v13 — Ethical Hacker", slug: "ceh-v13", start: "7 Sep 2026", days: "Mon–Thu (Weekdays)", time: "8:30–10:30 PM IST", seats: 12, left: 10, trainer: "Mrs. Anu" },
  { course: "AI Fundamentals & Prompt Engineering", slug: "ai-fundamentals", start: "14 Sep 2026", days: "Sat–Sun (Weekend)", time: "5:00–8:00 PM IST", seats: 20, left: 16, trainer: "Piyush Mahajan" },
];

export const FAQS = [
  {
    q: "How is LearnWithTAC different from other training institutes?",
    a: "We are the first academy offering true 1-to-1 live training — no batches, no recorded-only courses. Every session is a private class with a working industry engineer from companies like Cisco, Palo Alto, Microsoft and IBM, at the most affordable pricing in the market.",
  },
  {
    q: "Do I get recordings of my live classes?",
    a: "Yes. Every live session is recorded and shared with you after class, along with notes and timestamped lab walkthroughs — so you can revise anytime.",
  },
  {
    q: "What does 24x7 lab access include?",
    a: "You get a dedicated cloud lab pod with real topologies — Cisco, Palo Alto, FortiGate, F5, EVE-NG, AWS/Azure architectures and Kali attack boxes — accessible any time, even at 2 AM before your interview.",
  },
  {
    q: "I am a fresher with no IT background. Can I join?",
    a: "Absolutely. Most of our students start from zero. Your trainer builds a custom path starting from fundamentals (CCNA / Security+ / Cloud Practitioner) and takes you to job-ready level with mock interviews.",
  },
  {
    q: "Are mock interviews really included?",
    a: "Yes — technical mock interviews with real MNC interview rubrics are part of every job-track program, including resume building and referral guidance.",
  },
  {
    q: "What are the class timings?",
    a: "Since training is 1-on-1, timings are fully flexible and scheduled between you and your trainer — early morning, late night, or weekends.",
  },
  {
    q: "What is the refund policy?",
    a: "Fees are non-refundable once the program begins because your trainer's time is reserved exclusively for you — but we offer a free demo before payment, free trainer replacement, and a 12-month pause option. Full details are on our Refund Policy page linked in the footer.",
  },
  {
    q: "How do I enroll?",
    a: "Click the WhatsApp button or fill the contact form — our counsellor will schedule a free demo session with a trainer. Once you're happy, you enroll and get LMS + lab access within 24 hours.",
  },
];

export const POLICIES = {
  privacy: {
    title: "Privacy Policy",
    updated: "Last updated: July 2026",
    sections: [
      { h: "Information We Collect", p: "We collect your name, email address, phone number and course interest when you fill our contact forms or interact with us on WhatsApp. We also collect learning progress data inside our LMS portal to personalise your training." },
      { h: "How We Use Your Information", p: "Your details are used to schedule demo sessions, assign trainers, provide lab and LMS access, share course materials, and send important updates about your enrolled programs. We never sell your personal data to third parties." },
      { h: "Data Sharing", p: "We share minimal data only with service providers essential to deliver our training (LMS platform, lab infrastructure, CRM and communication tools), each bound by confidentiality obligations." },
      { h: "Data Security", p: "We use industry-standard encryption and access controls to protect your data. Lab pods are isolated per student and access credentials are rotated regularly." },
      { h: "Your Rights", p: "You may request access, correction or deletion of your personal data anytime by writing to info@learnwithtac.com. We respond to all requests within 7 working days." },
      { h: "Cookies", p: "Our website uses functional cookies for session management and anonymous analytics to improve your experience. You can disable cookies in your browser settings." },
    ],
  },
  refund: {
    title: "Cancellation & Refund Policy",
    updated: "Last updated: July 2026",
    sections: [
      { h: "Our Promise Before You Pay", p: "Every course at LearnWithTAC begins with a completely free 1-on-1 demo session. You meet your trainer, experience the teaching style, see the lab environment and get your full syllabus walkthrough — all before spending a single rupee. We request every student to enrol only when they are 100% satisfied." },
      { h: "No-Refund Policy — Explained Honestly", p: "Because our training is truly 1-on-1, a working industry expert reserves dedicated hours exclusively for you, and a personal lab pod is provisioned in your name the moment you enrol. For this reason, all course fees once paid are non-refundable. We say this openly rather than hiding it in fine print, and we encourage you to use the free demo to make a fully confident decision." },
      { h: "If Your Plans Change — We Still Help", p: "Life happens, and we understand. Instead of a refund, you can pause your program for up to 12 months and resume whenever you are ready, transfer your remaining sessions to another course of equal value, or transfer your seat to a friend or colleague at no extra cost." },
      { h: "Trainer Not a Fit? No Problem", p: "If at any point you feel your trainer's style doesn't match your learning pace, we assign a replacement trainer free of charge — as many times as needed until you are comfortable. Your learning experience is our responsibility." },
      { h: "Exceptional Circumstances", p: "In genuine emergencies such as serious medical situations, we review every case personally and with empathy. Write to us at info@learnwithtac.com with your enrolment ID and we will work out the fairest possible arrangement — typically a long-term pause or course credit." },
      { h: "How to Reach Us", p: "For any cancellation, pause or transfer request, simply email info@learnwithtac.com or message your counsellor on WhatsApp at +91 76961 18858. Every request is acknowledged within 24 hours and handled politely — you will always talk to a human, never a bot." },
    ],
  },
  payment: {
    title: "Terms & Payment Policy",
    updated: "Last updated: July 2026",
    sections: [
      { h: "Pricing", p: "All course prices are quoted per 1-on-1 program and include live classes, class recordings, PDF notes, 24x7 lab access and mock interviews. There are no hidden charges." },
      { h: "Payment Methods", p: "We accept UPI, net banking, credit/debit cards and international payments via secure payment gateways. EMI options are available on select programs." },
      { h: "Instalments", p: "Programs above a certain duration can be split into 2–3 interest-free instalments. Lab and LMS access remains active as long as instalments are on schedule." },
      { h: "Invoices", p: "A GST invoice is issued for every payment within 24 hours. Companies sponsoring employees can request customised invoicing." },
      { h: "Service Delivery", p: "LMS and lab access is provisioned within 24 hours of payment confirmation. The first live session is scheduled at a mutually convenient time within 72 hours." },
      { h: "Fair Usage", p: "Lab pods are for personal learning only. Sharing credentials, crypto-mining, or attacking infrastructure outside your pod leads to immediate suspension." },
    ],
  },
};
